import { render, staticRenderFns } from "./PublishUI.vue?vue&type=template&id=2203cfc3&scoped=true&"
import script from "./PublishUI.vue?vue&type=script&lang=js&"
export * from "./PublishUI.vue?vue&type=script&lang=js&"
import style0 from "./PublishUI.vue?vue&type=style&index=0&id=2203cfc3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203cfc3",
  null
  
)

export default component.exports